import { Link } from 'react-router-dom';
import './blogListComponent.css';

const categories = ['Agent systems', 'Production patterns', 'Technology strategy'];

const BlogListComponent = ({ blog, index }) => (
  <article className="insight-card">
    <Link className={`insight-card__visual insight-card__visual--${(index % 3) + 1}`} to={`/blog/${blog.name}`} aria-label={`Read ${blog.title}`}>
      <span>{String(index + 1).padStart(2, '0')}</span>
      <i aria-hidden="true" /><i aria-hidden="true" /><i aria-hidden="true" />
    </Link>
    <div className="insight-card__body">
      <div className="insight-card__meta">
        <span>{categories[index % categories.length]}</span>
        <span>{blog.readTime}</span>
      </div>
      <h3><Link to={`/blog/${blog.name}`}>{blog.title}</Link></h3>
      <p>{blog.subtitle}</p>
      <Link className="text-link" to={`/blog/${blog.name}`}>Read field note <span aria-hidden="true">↗</span></Link>
    </div>
  </article>
);

export default BlogListComponent;
